// // import React, { useEffect, useState } from "react";
// // import API from "../services/api";
// // import "../styles/packages.css";

// // function PackagesPage() {
// // const [dealCount, setDealCount] = useState(0);
// // const [editMode, setEditMode] = useState(false);
// // const [editId, setEditId] = useState(null);

// // const handleEdit = (deal) => {
// //   setForm(deal);
// //   setEditId(deal.id);
// //   setEditMode(true);
// //   setShow(true);
// // };
  
// //   const [deals, setDeals] = useState([]);
// //   const [show, setShow] = useState(false);
// //   const [selectedDeal, setSelectedDeal] = useState(null);

// //   const [form, setForm] = useState({
// //     contact_person: "",
// //     phone: "",
// //     business_name: "",
// //     email: "",
// //     package_name: "",
// //     product_name: "",
// //     validity: "",
// //     fos_name: "",
// //     tele_self: "",
// //     sale_type: "",
// //     category: "",
// //     payment_mode: "",
// //     total_amount: "",
// //     received_amount: "",
// //     pending_amount: 0,
// //     pending_details: "",
// //     invoice: "",
// //     address: "",
// //     domain_name: "",
// //     welcome_call_time: ""
// //   });

// //   useEffect(() => {
// //     fetchDeals();
// //   }, []);

// // const fetchDeals = async () => {
// //   const res = await API.get("/deals");


// //   const userId = localStorage.getItem("userId");
// //   const role = localStorage.getItem("role");

// //   let filteredDeals = [];

// //   if (role === "boss" || role === "it manager" || role === "sales manager") {
// //     filteredDeals = res.data;
// //   } else {
// //     filteredDeals = res.data.filter(
// //       (d) => String(d.created_by) === String(userId)
// //     );
// //   }

// //   setDeals(filteredDeals);
// //   setDealCount(filteredDeals.length);
// // };



// //   const packagePrices = {
// //     Basic: 25000,
// //     Classic: 45000,
// //     Advance: 70000,
// //     Premium: 85000
// //   };

// //   // ✅ STRONG VALIDATION HANDLER
// //   const handleChange = (e) => {
// //     let { name, value } = e.target;

// //     // 🔢 ONLY NUMBERS
// //     if (["phone", "total_amount", "received_amount"].includes(name)) {
// //       if (!/^\d*$/.test(value)) return;
// //     }

// //     // 📞 PHONE LIMIT
// //     if (name === "phone" && value.length > 10) return;

// //     // 🔤 ONLY ALPHABETS
// //     if (["contact_person", "business_name", "fos_name"].includes(name)) {
// //       if (!/^[a-zA-Z\s]*$/.test(value)) return;
// //     }

// //     // 📦 PACKAGE AUTO PRICE
// //     if (name === "package_name") {
// //       const price = packagePrices[value] || 0;

// //       setForm((prev) => ({
// //         ...prev,
// //         package_name: value,
// //         total_amount: price,
// //         pending_amount: price - (prev.received_amount || 0)
// //       }));
// //       return;
// //     }

// //     setForm((prev) => {
// //       const updated = { ...prev, [name]: value };

// //       updated.pending_amount =
// //         Number(updated.total_amount || 0) -
// //         Number(updated.received_amount || 0);

// //       return updated;
// //     });
// //   };

// //   // ✅ FORM VALIDATION
// //   const validateForm = () => {
// //     if (form.phone.length !== 10) {
// //       alert("Phone must be 10 digits");
// //       return false;
// //     }

// //     if (!form.business_name.trim()) {
// //       alert("Business Name required");
// //       return false;
// //     }

// //     if (!form.contact_person.trim()) {
// //       alert("Contact Person required");
// //       return false;
// //     }

// //     if (!form.package_name) {
// //       alert("Select Package");
// //       return false;
// //     }

// //     if (!form.received_amount) {
// //       alert("Enter received amount");
// //       return false;
// //     }

// //     if (Number(form.received_amount) > Number(form.total_amount)) {
// //       alert("Received > Total not allowed");
// //       return false;
// //     }

// //     return true;
// //   };

// //   // ✅ SUBMIT
// //  const handleSubmit = async (e) => {
// //   e.preventDefault();

// //   if (!validateForm()) return;

// //   if (editMode) {
// //     await API.put(`/deals/${editId}`, form);
// //   } else {
// //     await API.post("/deals", form);
// //   }

// //   setShow(false);
// //   setEditMode(false);
// //   setEditId(null);

// //   fetchDeals();
// // };

// //   const openDetails = (deal) => {
// //     setSelectedDeal(deal);
// //   };

// //   return (
// //     <div className="container">

// //       <div className="top-bar">
// //        <h2>Deals ({dealCount})</h2>
// //         <button onClick={() => setShow(true)}>+ Add Deal</button>
// //       </div>

// //       {/* ✅ CLEAN TABLE */}
// //       <div className="table">
// //         <table>
// //           <thead>
// //             <tr>
// //               <th>Business</th>
// //               <th>Phone</th>
// //               <th>Package</th>
// //               <th>Total</th>
// //               <th>Pending</th>
// //               <th>Action</th>
// //             </tr>
// //           </thead>

// //           <tbody>
// //             {deals.map((d) => (
// //               <tr key={d.id}>
// //                 <td>{d.business_name}</td>
// //                 <td>{d.phone}</td>
// //                 <td>{d.package_name}</td>
// //                 <td>₹{d.total_amount}</td>
// //                 <td>₹{d.pending_amount}</td>
// //                 <td>
// //   <button
// //     className="action-btn view-btn"
// //     onClick={() => openDetails(d)}
// //   >
// //     View
// //   </button>

// //   <button
// //     className="action-btn edit-btn"
// //     onClick={() => handleEdit(d)}
// //   >
// //     Edit
// //   </button>
// // </td>
// //               </tr>
// //             ))}
// //           </tbody>
// //         </table>
// //       </div>

// //       {/* ✅ ADD DEAL MODAL */}
// //       {show && (
// //         <div className="modal">
// //           <div className="modal-box">

// //             <h3>Add Deal</h3>

// //             <form onSubmit={handleSubmit}>

// //               <input
// //                 name="phone"
// //                 value={form.phone}
// //                 onChange={handleChange}
// //                 onKeyPress={(e) => !/[0-9]/.test(e.key) && e.preventDefault()}
// //                 onPaste={(e) => e.preventDefault()}
// //                 placeholder="Phone"
// //               />

// //               <input
// //                 name="contact_person"
// //                 value={form.contact_person}
// //                 onChange={handleChange}
// //                 onKeyPress={(e) => !/[a-zA-Z\s]/.test(e.key) && e.preventDefault()}
// //                 placeholder="Contact Person"
// //               />

// //               <input
// //                 name="business_name"
// //                 value={form.business_name}
// //                 onChange={handleChange}
// //                 onKeyPress={(e) => !/[a-zA-Z\s]/.test(e.key) && e.preventDefault()}
// //                 placeholder="Business Name"
// //               />

// //               <input name="email" type="email" onChange={handleChange} placeholder="Email" />

// //               <select name="package_name" onChange={handleChange}>
// //                 <option value="">Select Package</option>
// //                 <option value="Basic">Basic - ₹25,000+GST</option>
// //                 <option value="Classic">Classic - ₹45000+GST</option>
// //                 <option value="Advance">Advance - ₹70000+GST</option>
// //                 <option value="Premium">Premium - ₹85000+GST</option>
// //               </select>

// //               <select name="product_name" onChange={handleChange}>
// //                 <option>Website</option>
// //                 <option>SEO</option>
// //                 <option>Ads</option>
// //                 <option>CRM</option>
// //               </select>

// //               <select name="validity" onChange={handleChange}>
// //                 <option>1 Month</option>
// //                 <option>3 Months</option>
// //                 <option>6 Months</option>
// //                 <option>1 Year</option>
// //               </select>

// //               <input
// //                 name="fos_name"
// //                 value={form.fos_name}
// //                 onChange={handleChange}
// //                 onKeyPress={(e) => !/[a-zA-Z\s]/.test(e.key) && e.preventDefault()}
// //                 placeholder="Sales Representative"
// //               />

// //               <select name="tele_self" onChange={handleChange}>
// //                 <option>Telesales</option>
// //                 <option>Self</option>
// //               </select>

// //               <select name="sale_type" onChange={handleChange}>
// //                 <option>New</option>
// //                 <option>Renewal</option>
// //               </select>

// //               <select name="category" onChange={handleChange}>
// //                 <option>Hot</option>
// //                 <option>Warm</option>
// //                 <option>Cold</option>
// //               </select>

// //               <select name="payment_mode" onChange={handleChange}>
// //                 <option>UPI</option>
// //                 <option>Cash</option>
// //                 <option>Card</option>
// //                 <option>Bank Transfer</option>
// //               </select>

// //               <input name="total_amount" value={form.total_amount} readOnly />

// //               <input
// //                 name="received_amount"
// //                 value={form.received_amount}
// //                 onChange={handleChange}
// //                 onKeyPress={(e) => !/[0-9]/.test(e.key) && e.preventDefault()}
// //                 onPaste={(e) => e.preventDefault()}
// //                 placeholder="Received Amount"
// //               />

// //               <input value={form.pending_amount} readOnly placeholder="Pending Amount" />

// //               <textarea name="pending_details" onChange={handleChange} placeholder="Pending Details"></textarea>

// //               <input name="invoice" onChange={handleChange} placeholder="Invoice" />

// //               <input name="address" onChange={handleChange} placeholder="Address" />

// //               <input name="domain_name" onChange={handleChange} placeholder="Domain Name" />

// //               <input type="datetime-local" name="welcome_call_time" onChange={handleChange} />

// //               <div className="actions">
// //                 <button type="submit">Save</button>
// //                 <button type="button" onClick={() => setShow(false)}>Cancel</button>
// //               </div>

// //             </form>

// //           </div>
// //         </div>
// //       )}

// //       {/* ✅ DETAILS MODAL */}
// //       {selectedDeal && (
// //   <div className="modal">
// //     <div className="modal-box">

// //       <h3>Deal Details</h3>

// //       <div className="view-grid">

// //         <div className="view-card">
// //           <span>Business</span>
// //           <p>{selectedDeal.business_name}</p>
// //         </div>

// //         <div className="view-card">
// //           <span>Contact</span>
// //           <p>{selectedDeal.contact_person}</p>
// //         </div>

// //         <div className="view-card">
// //           <span>Phone</span>
// //           <p>{selectedDeal.phone}</p>
// //         </div>

// //         <div className="view-card">
// //           <span>Email</span>
// //           <p>{selectedDeal.email}</p>
// //         </div>

// //         <div className="view-card highlight">
// //           <span>Total</span>
// //           <p>₹{selectedDeal.total_amount}</p>
// //         </div>

// //         <div className="view-card highlight">
// //           <span>Pending</span>
// //           <p>₹{selectedDeal.pending_amount}</p>
// //         </div>

// //         <div className="view-card">
// //           <span>Package</span>
// //           <p>{selectedDeal.package_name}</p>
// //         </div>

// //         <div className="view-card">
// //           <span>Sales Person</span>
// //           <p>{selectedDeal.fos_name}</p>
// //         </div>

// //         <div className="view-card full">
// //           <span>Address</span>
// //           <p>{selectedDeal.address}</p>
// //         </div>

// //       </div>

// //       <div className="actions">
// //         <button onClick={() => setSelectedDeal(null)}>Close</button>
// //       </div>

// //     </div>
// //   </div>
// // )}
          

// //     </div>
// //   );
// // }

// // export default PackagesPage;


// import React, { useEffect, useState } from "react";
// import API from "../services/api";
// import "../styles/packages.css";

// const emptyForm = {
//   contact_person: "",
//   phone: "",
//   business_name: "",
//   email: "",
//   package_name: "",
//   product_name: "Website",
//   validity: "1 Month",
//   fos_name: "",
//   tele_self: "Telesales",
//   sale_type: "New",
//   category: "Hot",
//   payment_mode: "UPI",
//   total_amount: "",
//   received_amount: "",
//   pending_amount: 0,
//   pending_details: "",
//   invoice: "",
//   address: "",
//   domain_name: "",
//   welcome_call_time: ""
// };

// const packagePrices = {
//   Basic: 25000,
//   Classic: 45000,
//   Advance: 70000,
//   Premium: 85000
// };

// function PackagesPage() {
//   const [deals, setDeals] = useState([]);
//   const [dealCount, setDealCount] = useState(0);

//   const [show, setShow] = useState(false);
//   const [editMode, setEditMode] = useState(false);
//   const [editId, setEditId] = useState(null);

//   const [form, setForm] = useState(emptyForm);
//   const [selectedDeal, setSelectedDeal] = useState(null);
//   const [error, setError] = useState("");

//   useEffect(() => {
//     fetchDeals();
//   }, []);

//   // ==============================
//   // ✅ FETCH
//   // ==============================
//   const fetchDeals = async () => {
//     try {
//       const res = await API.get("/deals");

//       const userId = localStorage.getItem("userId");
//       const role = (localStorage.getItem("role") || "").toLowerCase();

//       let filtered = [];

//       if (role === "boss" || role === "it manager" || role === "sales manager") {
//         filtered = res.data;
//       } else {
//         filtered = res.data.filter(
//           (d) => String(d.created_by) === String(userId)
//         );
//       }

//       setDeals(filtered);
//       setDealCount(filtered.length);
//     } catch (err) {
//       console.log("FETCH ERROR:", err);
//       setError("Failed to load deals. Check server.");
//     }
//   };

//   // ==============================
//   // ✅ OPEN ADD MODAL (fresh form)
//   // ==============================
//   const openAdd = () => {
//     setForm(emptyForm);
//     setEditMode(false);
//     setEditId(null);
//     setError("");
//     setShow(true);
//   };

//   // ==============================
//   // ✅ OPEN EDIT MODAL
//   // ==============================
//   const handleEdit = (deal) => {
//     setForm({
//       contact_person: deal.contact_person || "",
//       phone: deal.phone || "",
//       business_name: deal.business_name || "",
//       email: deal.email || "",
//       package_name: deal.package_name || "",
//       product_name: deal.product_name || "Website",
//       validity: deal.validity || "1 Month",
//       fos_name: deal.fos_name || "",
//       tele_self: deal.tele_self || "Telesales",
//       sale_type: deal.sale_type || "New",
//       category: deal.category || "Hot",
//       payment_mode: deal.payment_mode || "UPI",
//       total_amount: deal.total_amount || "",
//       received_amount: deal.received_amount || "",
//       pending_amount: deal.pending_amount || 0,
//       pending_details: deal.pending_details || "",
//       invoice: deal.invoice || "",
//       address: deal.address || "",
//       domain_name: deal.domain_name || "",
//       welcome_call_time: deal.welcome_call_time
//         ? deal.welcome_call_time.slice(0, 16) // trim to datetime-local format
//         : ""
//     });
//     setEditId(deal.id);
//     setEditMode(true);
//     setError("");
//     setShow(true);
//   };

//   // ==============================
//   // ✅ FORM CHANGE HANDLER
//   // ==============================
//   const handleChange = (e) => {
//     let { name, value } = e.target;

//     // Numbers only
//     if (["phone", "total_amount", "received_amount"].includes(name)) {
//       if (!/^\d*$/.test(value)) return;
//     }

//     // Phone max 10 digits
//     if (name === "phone" && value.length > 10) return;

//     // Alphabets only
//     if (["contact_person", "fos_name"].includes(name)) {
//       if (!/^[a-zA-Z\s]*$/.test(value)) return;
//     }

//     // Auto-fill price on package select
//     if (name === "package_name") {
//       const price = packagePrices[value] || 0;
//       setForm((prev) => ({
//         ...prev,
//         package_name: value,
//         total_amount: price,
//         pending_amount: price - Number(prev.received_amount || 0)
//       }));
//       return;
//     }

//     // Recalculate pending on amount change
//     setForm((prev) => {
//       const updated = { ...prev, [name]: value };
//       updated.pending_amount =
//         Number(updated.total_amount || 0) - Number(updated.received_amount || 0);
//       return updated;
//     });
//   };

//   // ==============================
//   // ✅ VALIDATION
//   // ==============================
//   const validateForm = () => {
//     if (!form.phone || form.phone.length !== 10) {
//       setError("Phone must be 10 digits");
//       return false;
//     }
//     if (!form.business_name.trim()) {
//       setError("Business Name is required");
//       return false;
//     }
//     if (!form.contact_person.trim()) {
//       setError("Contact Person is required");
//       return false;
//     }
//     if (!form.package_name) {
//       setError("Select a Package");
//       return false;
//     }
//     if (!form.received_amount && form.received_amount !== 0) {
//       setError("Enter received amount");
//       return false;
//     }
//     if (Number(form.received_amount) > Number(form.total_amount)) {
//       setError("Received amount cannot exceed total amount");
//       return false;
//     }
//     return true;
//   };

//   // ==============================
//   // ✅ SUBMIT (ADD or EDIT)
//   // ==============================
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError("");

//     if (!validateForm()) return;

//     try {
//       if (editMode) {
//         await API.put(`/deals/${editId}`, form);
//       } else {
//         await API.post("/deals", form);
//       }

//       setShow(false);
//       setEditMode(false);
//       setEditId(null);
//       setForm(emptyForm);
//       fetchDeals();
//     } catch (err) {
//       console.log("SUBMIT ERROR:", err);
//       // ✅ Show actual server error message so you can debug
//       const msg = err?.response?.data?.message || "Server error. Check console.";
//       setError(msg);
//     }
//   };

//   const closeModal = () => {
//     setShow(false);
//     setEditMode(false);
//     setEditId(null);
//     setForm(emptyForm);
//     setError("");
//   };

//   // ==============================
//   // ✅ UI
//   // ==============================
//   return (
//     <div className="container">

//       <div className="top-bar">
//         <h2>Deals ({dealCount})</h2>
//         <button onClick={openAdd}>+ Add Deal</button>
//       </div>

//       {/* SERVER ERROR BANNER */}
//       {error && !show && (
//         <div style={{ background: "#fee2e2", color: "#b91c1c", padding: "10px", borderRadius: "6px", marginBottom: "12px" }}>
//           {error}
//         </div>
//       )}

//       {/* TABLE */}
//       <div className="table">
//         <table>
//           <thead>
//             <tr>
//               <th>Business</th>
//               <th>Phone</th>
//               <th>Package</th>
//               <th>Total</th>
//               <th>Received</th>
//               <th>Pending</th>
//               <th>Action</th>
//             </tr>
//           </thead>
//           <tbody>
//             {deals.length === 0 ? (
//               <tr>
//                 <td colSpan="7" style={{ textAlign: "center", padding: "20px", color: "#888" }}>
//                   No deals found
//                 </td>
//               </tr>
//             ) : (
//               deals.map((d) => (
//                 <tr key={d.id}>
//                   <td>{d.business_name}</td>
//                   <td>{d.phone}</td>
//                   <td>{d.package_name}</td>
//                   <td>₹{d.total_amount}</td>
//                   <td>₹{d.received_amount}</td>
//                   <td>₹{d.pending_amount}</td>
//                   <td>
//                     <button className="action-btn view-btn" onClick={() => setSelectedDeal(d)}>View</button>
//                     <button className="action-btn edit-btn" onClick={() => handleEdit(d)}>Edit</button>
//                   </td>
//                 </tr>
//               ))
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* ADD / EDIT MODAL */}
//       {show && (
//         <div className="modal">
//           <div className="modal-box">

//             <h3>{editMode ? "Edit Deal" : "Add Deal"}</h3>

//             {/* ✅ Show error inside modal */}
//             {error && (
//               <div style={{ background: "#fee2e2", color: "#b91c1c", padding: "8px 12px", borderRadius: "6px", marginBottom: "10px", fontSize: "14px" }}>
//                 {error}
//               </div>
//             )}

//             <form onSubmit={handleSubmit}>

//               <input
//                 name="phone"
//                 value={form.phone}
//                 onChange={handleChange}
//                 onKeyPress={(e) => !/[0-9]/.test(e.key) && e.preventDefault()}
//                 onPaste={(e) => e.preventDefault()}
//                 placeholder="Phone *"
//               />

//               <input
//                 name="contact_person"
//                 value={form.contact_person}
//                 onChange={handleChange}
//                 onKeyPress={(e) => !/[a-zA-Z\s]/.test(e.key) && e.preventDefault()}
//                 placeholder="Contact Person *"
//               />

//               <input
//                 name="business_name"
//                 value={form.business_name}
//                 onChange={handleChange}
//                 placeholder="Business Name *"
//               />

//               <input
//                 name="email"
//                 type="email"
//                 value={form.email}
//                 onChange={handleChange}
//                 placeholder="Email"
//               />

//               <select name="package_name" value={form.package_name} onChange={handleChange}>
//                 <option value="">Select Package *</option>
//                 <option value="Basic">Basic - ₹25,000+GST</option>
//                 <option value="Classic">Classic - ₹45,000+GST</option>
//                 <option value="Advance">Advance - ₹70,000+GST</option>
//                 <option value="Premium">Premium - ₹85,000+GST</option>
//               </select>

//               <select name="product_name" value={form.product_name} onChange={handleChange}>
//                 <option value="Website">Website</option>
//                 <option value="SEO">SEO</option>
//                 <option value="Ads">Ads</option>
//                 <option value="CRM">CRM</option>
//               </select>

//               <select name="validity" value={form.validity} onChange={handleChange}>
//                 <option value="1 Month">1 Month</option>
//                 <option value="3 Months">3 Months</option>
//                 <option value="6 Months">6 Months</option>
//                 <option value="1 Year">1 Year</option>
//               </select>

//               <input
//                 name="fos_name"
//                 value={form.fos_name}
//                 onChange={handleChange}
//                 onKeyPress={(e) => !/[a-zA-Z\s]/.test(e.key) && e.preventDefault()}
//                 placeholder="Sales Representative"
//               />

//               <select name="tele_self" value={form.tele_self} onChange={handleChange}>
//                 <option value="Telesales">Telesales</option>
//                 <option value="Self">Self</option>
//               </select>

//               <select name="sale_type" value={form.sale_type} onChange={handleChange}>
//                 <option value="New">New</option>
//                 <option value="Renewal">Renewal</option>
//               </select>

//               <select name="category" value={form.category} onChange={handleChange}>
//                 <option value="Hot">Hot</option>
//                 <option value="Warm">Warm</option>
//                 <option value="Cold">Cold</option>
//               </select>

//               <select name="payment_mode" value={form.payment_mode} onChange={handleChange}>
//                 <option value="UPI">UPI</option>
//                 <option value="Cash">Cash</option>
//                 <option value="Card">Card</option>
//                 <option value="Bank Transfer">Bank Transfer</option>
//               </select>

//               {/* ✅ Total is read-only — auto filled by package selection */}
//               <input
//                 name="total_amount"
//                 value={form.total_amount}
//                 readOnly
//                 placeholder="Total Amount (auto)"
//               />

//               <input
//                 name="received_amount"
//                 value={form.received_amount}
//                 onChange={handleChange}
//                 onKeyPress={(e) => !/[0-9]/.test(e.key) && e.preventDefault()}
//                 onPaste={(e) => e.preventDefault()}
//                 placeholder="Received Amount *"
//               />

//               {/* ✅ Pending is read-only — auto calculated */}
//               <input
//                 value={form.pending_amount}
//                 readOnly
//                 placeholder="Pending Amount (auto)"
//               />

//               <textarea
//                 name="pending_details"
//                 value={form.pending_details}
//                 onChange={handleChange}
//                 placeholder="Pending Details"
//               />

//               <input
//                 name="invoice"
//                 value={form.invoice}
//                 onChange={handleChange}
//                 placeholder="Invoice"
//               />

//               <input
//                 name="address"
//                 value={form.address}
//                 onChange={handleChange}
//                 placeholder="Address"
//               />

//               <input
//                 name="domain_name"
//                 value={form.domain_name}
//                 onChange={handleChange}
//                 placeholder="Domain Name"
//               />

//               <input
//                 type="datetime-local"
//                 name="welcome_call_time"
//                 value={form.welcome_call_time}
//                 onChange={handleChange}
//               />

//               <div className="actions">
//                 <button type="submit">{editMode ? "Update" : "Save"}</button>
//                 <button type="button" onClick={closeModal}>Cancel</button>
//               </div>

//             </form>
//           </div>
//         </div>
//       )}

//       {/* VIEW DETAILS MODAL */}
//       {selectedDeal && (
//         <div className="modal">
//           <div className="modal-box">

//             <h3>Deal Details</h3>

//             <div className="view-grid">
//               <div className="view-card"><span>Business</span><p>{selectedDeal.business_name}</p></div>
//               <div className="view-card"><span>Contact</span><p>{selectedDeal.contact_person}</p></div>
//               <div className="view-card"><span>Phone</span><p>{selectedDeal.phone}</p></div>
//               <div className="view-card"><span>Email</span><p>{selectedDeal.email}</p></div>
//               <div className="view-card"><span>Package</span><p>{selectedDeal.package_name}</p></div>
//               <div className="view-card"><span>Product</span><p>{selectedDeal.product_name}</p></div>
//               <div className="view-card"><span>Validity</span><p>{selectedDeal.validity}</p></div>
//               <div className="view-card"><span>Sales Rep</span><p>{selectedDeal.fos_name}</p></div>
//               <div className="view-card"><span>Sale Type</span><p>{selectedDeal.sale_type}</p></div>
//               <div className="view-card"><span>Category</span><p>{selectedDeal.category}</p></div>
//               <div className="view-card"><span>Payment Mode</span><p>{selectedDeal.payment_mode}</p></div>
//               <div className="view-card highlight"><span>Total</span><p>₹{selectedDeal.total_amount}</p></div>
//               <div className="view-card highlight"><span>Received</span><p>₹{selectedDeal.received_amount}</p></div>
//               <div className="view-card highlight"><span>Pending</span><p>₹{selectedDeal.pending_amount}</p></div>
//               <div className="view-card full"><span>Address</span><p>{selectedDeal.address}</p></div>
//               <div className="view-card full"><span>Domain</span><p>{selectedDeal.domain_name}</p></div>
//               <div className="view-card full"><span>Pending Details</span><p>{selectedDeal.pending_details}</p></div>
//             </div>

//             <div className="actions">
//               <button onClick={() => setSelectedDeal(null)}>Close</button>
//             </div>

//           </div>
//         </div>
//       )}

//     </div>
//   );
// }

// export default PackagesPage;

import React, { useEffect, useState } from "react";
import API from "../services/api";
import "../styles/packages.css";

const emptyForm = {
  contact_person: "",
  phone: "",
  business_name: "",
  email: "",
  package_name: "",
  product_name: "Website",
  validity: "1 Month",
  fos_name: "",
  tele_self: "Telesales",
  sale_type: "New",
  category: "Hot",
  payment_mode: "UPI",
  total_amount: "",
  received_amount: "",
  pending_amount: 0,
  pending_details: "",
  invoice: "",
  address: "",
  domain_name: "",
  welcome_call_time: "",
};

const packagePrices = {
  Basic: 25000,
  Classic: 45000,
  Advance: 70000,
  Premium: 85000,
};

const categoryColors = {
  Hot: "cat-hot",
  Warm: "cat-warm",
  Cold: "cat-cold",
};

const packageColors = {
  Basic: "pkg-basic",
  Classic: "pkg-classic",
  Advance: "pkg-advance",
  Premium: "pkg-premium",
};

function PackagesPage() {
  const [deals, setDeals] = useState([]);
  const [dealCount, setDealCount] = useState(0);
  const [show, setShow] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [editId, setEditId] = useState(null);
  const [form, setForm] = useState(emptyForm);
  const [selectedDeal, setSelectedDeal] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchDeals();
  }, []);

  const fetchDeals = async () => {
    try {
      const res = await API.get("/deals");
      const userId = localStorage.getItem("userId");
      const role = (localStorage.getItem("role") || "").toLowerCase();
      let filtered =
        role === "boss" || role === "it manager" || role === "sales manager"
          ? res.data
          : res.data.filter((d) => String(d.created_by) === String(userId));
      setDeals(filtered);
      setDealCount(filtered.length);
    } catch (err) {
      setError("Failed to load deals.");
    }
  };

  const openAdd = () => {
    setForm(emptyForm);
    setEditMode(false);
    setEditId(null);
    setError("");
    setShow(true);
  };

  const handleEdit = (deal) => {
    setForm({
      contact_person: deal.contact_person || "",
      phone: deal.phone || "",
      business_name: deal.business_name || "",
      email: deal.email || "",
      package_name: deal.package_name || "",
      product_name: deal.product_name || "Website",
      validity: deal.validity || "1 Month",
      fos_name: deal.fos_name || "",
      tele_self: deal.tele_self || "Telesales",
      sale_type: deal.sale_type || "New",
      category: deal.category || "Hot",
      payment_mode: deal.payment_mode || "UPI",
      total_amount: deal.total_amount || "",
      received_amount: deal.received_amount || "",
      pending_amount: deal.pending_amount || 0,
      pending_details: deal.pending_details || "",
      invoice: deal.invoice || "",
      address: deal.address || "",
      domain_name: deal.domain_name || "",
      welcome_call_time: deal.welcome_call_time
        ? deal.welcome_call_time.slice(0, 16)
        : "",
    });
    setEditId(deal.id);
    setEditMode(true);
    setError("");
    setShow(true);
  };

  const handleChange = (e) => {
    let { name, value } = e.target;

    if (["phone", "total_amount", "received_amount"].includes(name)) {
      if (!/^\d*$/.test(value)) return;
    }
    if (name === "phone" && value.length > 10) return;
    if (["contact_person", "fos_name"].includes(name)) {
      if (!/^[a-zA-Z\s]*$/.test(value)) return;
    }

    if (name === "package_name") {
      const price = packagePrices[value] || 0;
      setForm((prev) => ({
        ...prev,
        package_name: value,
        total_amount: price,
        pending_amount: price - Number(prev.received_amount || 0),
      }));
      return;
    }

    setForm((prev) => {
      const updated = { ...prev, [name]: value };
      updated.pending_amount =
        Number(updated.total_amount || 0) -
        Number(updated.received_amount || 0);
      return updated;
    });
  };

  const validateForm = () => {
    if (!form.phone || form.phone.length !== 10) {
      setError("Phone must be exactly 10 digits");
      return false;
    }
    if (!form.business_name.trim()) {
      setError("Business name is required");
      return false;
    }
    if (!form.contact_person.trim()) {
      setError("Contact person is required");
      return false;
    }
    if (!form.package_name) {
      setError("Please select a package");
      return false;
    }
    if (!form.received_amount && form.received_amount !== 0) {
      setError("Enter received amount");
      return false;
    }
    if (Number(form.received_amount) > Number(form.total_amount)) {
      setError("Received amount cannot exceed total amount");
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!validateForm()) return;
    try {
      if (editMode) {
        await API.put(`/deals/${editId}`, form);
      } else {
        await API.post("/deals", form);
      }
      closeModal();
      fetchDeals();
    } catch (err) {
      setError(err?.response?.data?.message || "Server error. Try again.");
    }
  };

  const closeModal = () => {
    setShow(false);
    setEditMode(false);
    setEditId(null);
    setForm(emptyForm);
    setError("");
  };

  /* ── summary stats ── */
  const totalRevenue = deals.reduce((s, d) => s + Number(d.total_amount || 0), 0);
  const totalReceived = deals.reduce((s, d) => s + Number(d.received_amount || 0), 0);
  const totalPending = deals.reduce((s, d) => s + Number(d.pending_amount || 0), 0);

  return (
    <div className="pk-page">

      {/* ── HEADER ── */}
      <div className="pk-header">
        <div className="pk-header-left">
          <div className="pk-brand">
            {/* <div className="pk-brand-icon">DM</div>
            <span className="pk-brand-name">DigiMark CRM</span> */}
          </div>
          <h1 className="pk-title">Deals</h1>
          <p className="pk-subtitle">Track and manage all your sales deals</p>
        </div>
        <button className="pk-add-btn" onClick={openAdd}>
          <span>+</span> Add deal
        </button>
      </div>

      {/* ── STATS ── */}
      <div className="pk-stats">
        <div className="pk-stat">
          <span className="pk-stat-label">Total deals</span>
          <span className="pk-stat-value">{dealCount}</span>
          <span className="pk-stat-badge badge-blue">All time</span>
        </div>
        <div className="pk-stat">
          <span className="pk-stat-label">Total revenue</span>
          <span className="pk-stat-value">₹{totalRevenue.toLocaleString("en-IN")}</span>
          <span className="pk-stat-badge badge-blue">Contracted</span>
        </div>
        <div className="pk-stat">
          <span className="pk-stat-label">Received</span>
          <span className="pk-stat-value">₹{totalReceived.toLocaleString("en-IN")}</span>
          <span className="pk-stat-badge badge-green">Collected</span>
        </div>
        <div className="pk-stat">
          <span className="pk-stat-label">Pending</span>
          <span className="pk-stat-value">₹{totalPending.toLocaleString("en-IN")}</span>
          <span className="pk-stat-badge badge-orange">Outstanding</span>
        </div>
      </div>

      {/* ── ERROR BANNER ── */}
      {error && !show && (
        <div className="pk-error-banner">{error}</div>
      )}

      {/* ── TABLE ── */}
      <div className="pk-table-wrap">
        <div className="pk-table-header">
          <h2 className="pk-section-title">All deals</h2>
          <button className="pk-refresh-btn" onClick={fetchDeals}>↻ Refresh</button>
        </div>

        <div className="pk-table-scroll">
          <table className="pk-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Business</th>
                <th>Contact</th>
                <th>Phone</th>
                <th>Package</th>
                <th>Category</th>
                <th>Total</th>
                <th>Received</th>
                <th>Pending</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {deals.length === 0 ? (
                <tr>
                  <td colSpan="10" className="pk-empty-row">
                    No deals yet. Click <strong>Add deal</strong> to get started.
                  </td>
                </tr>
              ) : (
                deals.map((d, i) => (
                  <tr key={d.id}>
                    <td className="pk-row-num">{i + 1}</td>
                    <td className="pk-business">{d.business_name}</td>
                    <td>{d.contact_person}</td>
                    <td>{d.phone}</td>
                    <td>
                      <span className={`pk-pkg-badge ${packageColors[d.package_name] || ""}`}>
                        {d.package_name}
                      </span>
                    </td>
                    <td>
                      <span className={`pk-cat-badge ${categoryColors[d.category] || ""}`}>
                        {d.category}
                      </span>
                    </td>
                    <td className="pk-amount">₹{Number(d.total_amount).toLocaleString("en-IN")}</td>
                    <td className="pk-amount pk-received">₹{Number(d.received_amount).toLocaleString("en-IN")}</td>
                    <td className="pk-amount pk-pending">₹{Number(d.pending_amount).toLocaleString("en-IN")}</td>
                    <td>
                      <div className="pk-actions">
                        <button className="pk-view-btn" onClick={() => setSelectedDeal(d)}>View</button>
                        <button className="pk-edit-btn" onClick={() => handleEdit(d)}>Edit</button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* ── ADD / EDIT MODAL ── */}
      {show && (
        <div className="pk-overlay" onClick={(e) => e.target === e.currentTarget && closeModal()}>
          <div className="pk-modal">
            <div className="pk-modal-head">
              <div>
                <h3 className="pk-modal-title">{editMode ? "Edit deal" : "Add new deal"}</h3>
                <p className="pk-modal-sub">Fill in the deal information below</p>
              </div>
              <button className="pk-close-btn" onClick={closeModal}>✕</button>
            </div>

            {error && <div className="pk-modal-error">{error}</div>}

            <form onSubmit={handleSubmit} className="pk-form">

              {/* Contact info section */}
              <div className="pk-form-section">
                <div className="pk-form-section-title">Contact information</div>
                <div className="pk-form-row-3">
                  <div className="pk-fg">
                    <label className="pk-label">Phone *</label>
                    <input className="pk-input" name="phone" value={form.phone}
                      onChange={handleChange}
                      onKeyPress={(e) => !/[0-9]/.test(e.key) && e.preventDefault()}
                      onPaste={(e) => e.preventDefault()}
                      placeholder="10-digit number" />
                  </div>
                  <div className="pk-fg">
                    <label className="pk-label">Contact person *</label>
                    <input className="pk-input" name="contact_person" value={form.contact_person}
                      onChange={handleChange}
                      onKeyPress={(e) => !/[a-zA-Z\s]/.test(e.key) && e.preventDefault()}
                      placeholder="Full name" />
                  </div>
                  <div className="pk-fg">
                    <label className="pk-label">Business name *</label>
                    <input className="pk-input" name="business_name" value={form.business_name}
                      onChange={handleChange} placeholder="Company name" />
                  </div>
                </div>
                <div className="pk-fg">
                  <label className="pk-label">Email</label>
                  <input className="pk-input" name="email" type="email" value={form.email}
                    onChange={handleChange} placeholder="email@company.com" />
                </div>
              </div>

              {/* Package info */}
              <div className="pk-form-section">
                <div className="pk-form-section-title">Package details</div>
                <div className="pk-form-row-3">
                  <div className="pk-fg">
                    <label className="pk-label">Package *</label>
                    <select className="pk-input" name="package_name" value={form.package_name} onChange={handleChange}>
                      <option value="">Select package</option>
                      <option value="Basic">Basic — ₹25,000 + GST</option>
                      <option value="Classic">Classic — ₹45,000 + GST</option>
                      <option value="Advance">Advance — ₹70,000 + GST</option>
                      <option value="Premium">Premium — ₹85,000 + GST</option>
                    </select>
                  </div>
                  <div className="pk-fg">
                    <label className="pk-label">Product</label>
                    <select className="pk-input" name="product_name" value={form.product_name} onChange={handleChange}>
                      <option value="Website">Website</option>
                      <option value="SEO">SEO</option>
                      <option value="Ads">Ads</option>
                      <option value="CRM">CRM</option>
                    </select>
                  </div>
                  <div className="pk-fg">
                    <label className="pk-label">Validity</label>
                    <select className="pk-input" name="validity" value={form.validity} onChange={handleChange}>
                      <option value="1 Month">1 month</option>
                      <option value="3 Months">3 months</option>
                      <option value="6 Months">6 months</option>
                      <option value="1 Year">1 year</option>
                    </select>
                  </div>
                </div>
              </div>

              {/* Sale info */}
              <div className="pk-form-section">
                <div className="pk-form-section-title">Sale information</div>
                <div className="pk-form-row-3">
                  <div className="pk-fg">
                    <label className="pk-label">Sales representative</label>
                    <input className="pk-input" name="fos_name" value={form.fos_name}
                      onChange={handleChange}
                      onKeyPress={(e) => !/[a-zA-Z\s]/.test(e.key) && e.preventDefault()}
                      placeholder="Rep name" />
                  </div>
                  <div className="pk-fg">
                    <label className="pk-label">Source</label>
                    <select className="pk-input" name="tele_self" value={form.tele_self} onChange={handleChange}>
                      <option value="Telesales">Telesales</option>
                      <option value="Self">Self</option>
                    </select>
                  </div>
                  <div className="pk-fg">
                    <label className="pk-label">Sale type</label>
                    <select className="pk-input" name="sale_type" value={form.sale_type} onChange={handleChange}>
                      <option value="New">New</option>
                      <option value="Renewal">Renewal</option>
                    </select>
                  </div>
                </div>
                <div className="pk-form-row-2">
                  <div className="pk-fg">
                    <label className="pk-label">Category</label>
                    <select className="pk-input" name="category" value={form.category} onChange={handleChange}>
                      <option value="Hot">Hot</option>
                      <option value="Warm">Warm</option>
                      <option value="Cold">Cold</option>
                    </select>
                  </div>
                  <div className="pk-fg">
                    <label className="pk-label">Payment mode</label>
                    <select className="pk-input" name="payment_mode" value={form.payment_mode} onChange={handleChange}>
                      <option value="UPI">UPI</option>
                      <option value="Cash">Cash</option>
                      <option value="Card">Card</option>
                      <option value="Bank Transfer">Bank transfer</option>
                    </select>
                  </div>
                </div>
              </div>

              {/* Payment */}
              <div className="pk-form-section">
                <div className="pk-form-section-title">Payment details</div>
                <div className="pk-form-row-3">
                  <div className="pk-fg">
                    <label className="pk-label">Total amount</label>
                    <input className="pk-input pk-readonly" name="total_amount"
                      value={form.total_amount ? `₹${Number(form.total_amount).toLocaleString("en-IN")}` : ""}
                      readOnly placeholder="Auto-filled from package" />
                  </div>
                  <div className="pk-fg">
                    <label className="pk-label">Received amount *</label>
                    <input className="pk-input" name="received_amount" value={form.received_amount}
                      onChange={handleChange}
                      onKeyPress={(e) => !/[0-9]/.test(e.key) && e.preventDefault()}
                      onPaste={(e) => e.preventDefault()}
                      placeholder="Amount collected" />
                  </div>
                  <div className="pk-fg">
                    <label className="pk-label">Pending amount</label>
                    <input className="pk-input pk-readonly pk-pending-input"
                      value={form.pending_amount ? `₹${Number(form.pending_amount).toLocaleString("en-IN")}` : "₹0"}
                      readOnly />
                  </div>
                </div>
                <div className="pk-fg">
                  <label className="pk-label">Pending details</label>
                  <textarea className="pk-input pk-textarea" name="pending_details"
                    value={form.pending_details} onChange={handleChange}
                    placeholder="Notes about pending payment..." />
                </div>
              </div>

              {/* Other info */}
              <div className="pk-form-section">
                <div className="pk-form-section-title">Other information</div>
                <div className="pk-form-row-2">
                  <div className="pk-fg">
                    <label className="pk-label">Invoice</label>
                    <input className="pk-input" name="invoice" value={form.invoice}
                      onChange={handleChange} placeholder="Invoice number" />
                  </div>
                  <div className="pk-fg">
                    <label className="pk-label">Domain name</label>
                    <input className="pk-input" name="domain_name" value={form.domain_name}
                      onChange={handleChange} placeholder="example.com" />
                  </div>
                </div>
                <div className="pk-fg">
                  <label className="pk-label">Address</label>
                  <input className="pk-input" name="address" value={form.address}
                    onChange={handleChange} placeholder="Business address" />
                </div>
                <div className="pk-fg">
                  <label className="pk-label">Welcome call time</label>
                  <input className="pk-input" type="datetime-local" name="welcome_call_time"
                    value={form.welcome_call_time} onChange={handleChange} />
                </div>
              </div>

              <div className="pk-form-actions">
                <button type="submit" className="pk-btn-save">
                  {editMode ? "Update deal" : "Save deal"}
                </button>
                <button type="button" className="pk-btn-cancel" onClick={closeModal}>
                  Cancel
                </button>
              </div>

            </form>
          </div>
        </div>
      )}

      {/* ── VIEW DETAILS MODAL ── */}
      {selectedDeal && (
        <div className="pk-overlay" onClick={(e) => e.target === e.currentTarget && setSelectedDeal(null)}>
          <div className="pk-modal pk-modal-view">
            <div className="pk-modal-head">
              <div>
                <h3 className="pk-modal-title">Deal details</h3>
                <p className="pk-modal-sub">{selectedDeal.business_name}</p>
              </div>
              <button className="pk-close-btn" onClick={() => setSelectedDeal(null)}>✕</button>
            </div>

            {/* Financial highlight strip */}
            <div className="pk-detail-strip">
              <div className="pk-strip-item">
                <span className="pk-strip-label">Total</span>
                <span className="pk-strip-val">₹{Number(selectedDeal.total_amount).toLocaleString("en-IN")}</span>
              </div>
              <div className="pk-strip-divider" />
              <div className="pk-strip-item">
                <span className="pk-strip-label">Received</span>
                <span className="pk-strip-val pk-strip-green">₹{Number(selectedDeal.received_amount).toLocaleString("en-IN")}</span>
              </div>
              <div className="pk-strip-divider" />
              <div className="pk-strip-item">
                <span className="pk-strip-label">Pending</span>
                <span className="pk-strip-val pk-strip-orange">₹{Number(selectedDeal.pending_amount).toLocaleString("en-IN")}</span>
              </div>
            </div>

            <div className="pk-view-grid">
              <div className="pk-view-card"><span>Contact person</span><p>{selectedDeal.contact_person}</p></div>
              <div className="pk-view-card"><span>Phone</span><p>{selectedDeal.phone}</p></div>
              <div className="pk-view-card"><span>Email</span><p>{selectedDeal.email || "—"}</p></div>
              <div className="pk-view-card"><span>Package</span>
                <p><span className={`pk-pkg-badge ${packageColors[selectedDeal.package_name] || ""}`}>{selectedDeal.package_name}</span></p>
              </div>
              <div className="pk-view-card"><span>Product</span><p>{selectedDeal.product_name}</p></div>
              <div className="pk-view-card"><span>Validity</span><p>{selectedDeal.validity}</p></div>
              <div className="pk-view-card"><span>Sales rep</span><p>{selectedDeal.fos_name || "—"}</p></div>
              <div className="pk-view-card"><span>Source</span><p>{selectedDeal.tele_self}</p></div>
              <div className="pk-view-card"><span>Sale type</span><p>{selectedDeal.sale_type}</p></div>
              <div className="pk-view-card"><span>Category</span>
                <p><span className={`pk-cat-badge ${categoryColors[selectedDeal.category] || ""}`}>{selectedDeal.category}</span></p>
              </div>
              <div className="pk-view-card"><span>Payment mode</span><p>{selectedDeal.payment_mode}</p></div>
              <div className="pk-view-card"><span>Invoice</span><p>{selectedDeal.invoice || "—"}</p></div>
              <div className="pk-view-card pk-view-full"><span>Address</span><p>{selectedDeal.address || "—"}</p></div>
              <div className="pk-view-card pk-view-full"><span>Domain</span><p>{selectedDeal.domain_name || "—"}</p></div>
              {selectedDeal.pending_details && (
                <div className="pk-view-card pk-view-full"><span>Pending details</span><p>{selectedDeal.pending_details}</p></div>
              )}
            </div>

            <div className="pk-form-actions">
              <button className="pk-btn-cancel" onClick={() => setSelectedDeal(null)}>Close</button>
              <button className="pk-btn-edit-detail" onClick={() => { setSelectedDeal(null); handleEdit(selectedDeal); }}>Edit this deal</button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}

export default PackagesPage;